export type Weekday = 0 | 1 | 2 | 3 | 4 | 5 | 6

export interface WeeklyBlock {
  id: string
  weekday: Weekday
  start_time: string
  end_time: string
}

export type DateOverrideKind = 'block' | 'extra'

export interface DateOverride {
  id: string
  date: string
  kind: DateOverrideKind
  start_time: string | null
  end_time: string | null
}

export interface Availability {
  recurring_blocks: WeeklyBlock[]
  date_overrides: DateOverride[]
}

export const WEEKDAY_LABELS: Record<Weekday, string> = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}

export const WEEKDAYS_ORDERED: Weekday[] = [1, 2, 3, 4, 5, 6, 0]
